import { CargoOperationTypeEnum } from '../../../enums/cargoOperationTypeEnum';
import { BerthCall } from '../../../types/ViewModel/BerthCall';
import { CargoOperation } from '../../../types/ViewModel/CargoOperation';
import { BerthOperationBM } from '../../../types/BusinessModel/BerthOperationBM';
import { ReportLocationEnum } from '../../../enums/reportLocationEnum';
import { MoveActionMsg } from '../../../types/ViewModel/ActionMsg';

export const setCargoOperationDetails = (operationType: CargoOperationTypeEnum | null, weight: number | null, tradeName: string | null): string => {
    if (weight && tradeName) {
        return (operationType === CargoOperationTypeEnum.Unloading ? '(U)' : '(L)') + ' ' + weight + ' MT ' + tradeName;
    }
    return 'Unknown cargo operation';
};

export const newCargoOperation = (cargoOperation: BerthOperationBM): CargoOperation | null => {
    if (cargoOperation) {
        const displayWeight = Math.abs(
            cargoOperation.billOfLadingWeight.value > 0 ? cargoOperation.billOfLadingWeight.value : cargoOperation.nominatedWeight.value
        );
        const details = setCargoOperationDetails(cargoOperation.cargoOperationType, displayWeight, cargoOperation.cargo.tradeName);
        return new CargoOperation(
            cargoOperation.imosCargoOperationId,
            cargoOperation.cargoOperationType,
            Math.abs(cargoOperation.nominatedWeight.value),
            Math.abs(cargoOperation.billOfLadingWeight.value),
            displayWeight,
            cargoOperation.cargo.productId,
            cargoOperation.cargo.cargoNumber,
            cargoOperation.cargo.cargoId,
            cargoOperation.cargo.imosCargoId,
            cargoOperation.cargo.tradeName,
            cargoOperation.cargo.chartererName.trimRight(),
            cargoOperation.isTransshipmentOperation,
            cargoOperation.cargo.cargoNumber + ' ' + details,
            details,
            null, //cargoOperation.berthCall,
            cargoOperation.cargo.colorRgb,
            '',
            false,
            ReportLocationEnum.Port,
            false,
            null,
            null,
            cargoOperation.demurrageRatePerDay,
            cargoOperation.pumpingRatePerHour,
            cargoOperation.cargo.cpDate
        );
    }
    return null;
};

export const newCargoOperationFromCode = (cargoOperation: CargoOperation | null, berthCall: BerthCall | null): CargoOperation | null => {
    if (cargoOperation) {
        const opType = cargoOperation.isLoading ? 0 : 1;
        const co = new CargoOperation(
            cargoOperation.cargoOperationId,
            opType,
            cargoOperation.nominatedWeight,
            cargoOperation.billOfLadingWeight,
            cargoOperation.displayWeight,
            cargoOperation.productId,
            cargoOperation.cargoNumber,
            cargoOperation.cargoId,
            cargoOperation.imosCargoId,
            cargoOperation.tradeName,
            cargoOperation.chartererName,
            cargoOperation.isTransshipmentOperation,
            cargoOperation.name,
            cargoOperation.details,
            berthCall,
            cargoOperation.colorRgb,
            cargoOperation.nodeStatus,
            cargoOperation.isDeleted,
            cargoOperation.reportLocation,
            cargoOperation.isMovedTo,
            cargoOperation.delayInputWarningText,
            cargoOperation.firstTimeInPortCall,
            cargoOperation.demurrageRatePerDay,
            cargoOperation.pumpingRatePerHour,
            cargoOperation.cpDate
        );
        if (co) {
            co.isLoading = cargoOperation.isLoading;
            co.isUnloading = cargoOperation.isUnloading;
            co.isSelected = cargoOperation.isSelected;
            co.dropDownName = cargoOperation.dropDownName;
            co.isMoved = cargoOperation.isMoved;
            co.isLocked = cargoOperation.isLocked;
            co.deletedIconTooltipText = cargoOperation.deletedIconTooltipText;
            co.aolDate = cargoOperation.aolDate;

            if (cargoOperation.portCall) {
                co.portCall = cargoOperation.portCall;
            }
            co.actionMsg = new MoveActionMsg(
                cargoOperation.actionMsg.displayMoveIcon,
                cargoOperation.actionMsg.message,
                cargoOperation.actionMsg.doAction,
                cargoOperation.actionMsg.toolTipText,
                cargoOperation.actionMsg.moveToNodeText,
                cargoOperation.actionMsg.id
            );
        }
        return co;
    }
    return null;
};

export const newDeletedCargoOperationFromCode = (
    cargoOperationId: number | null,
    berthCall: BerthCall,
    cargoNumber: string | null,
    cargoId: number | null,
    imosCargoId: number | null,
    operationType: CargoOperationTypeEnum | null,
    weight: number | null,
    tradeName: string | null,
    isMovedTo: boolean
): CargoOperation => {
    const details = setCargoOperationDetails(operationType, weight, tradeName);

    if (!cargoNumber) {
        cargoNumber = '???';
    }

    return new CargoOperation(
        cargoOperationId,
        operationType,
        0,
        0,
        weight,
        0,
        cargoNumber,
        cargoId,
        imosCargoId,
        tradeName,
        '',
        false,
        cargoNumber + ' ' + details,
        details,
        berthCall,
        '',
        '',
        true,
        ReportLocationEnum.Port,
        isMovedTo,
        null,
        null,
        null,
        null,
        null
    );
};
